import { render, staticRenderFns } from "./AppPatientCreateEditDialog.vue?vue&type=template&id=ea6676c6&scoped=true&"
import script from "./AppPatientCreateEditDialog.vue?vue&type=script&lang=js&"
export * from "./AppPatientCreateEditDialog.vue?vue&type=script&lang=js&"
import style0 from "./AppPatientCreateEditDialog.vue?vue&type=style&index=0&id=ea6676c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea6676c6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCardText,VTextField})
